import { render, staticRenderFns } from "./Blankslate.vue?vue&type=template&id=0530c66e&scoped=true&"
import script from "./Blankslate.vue?vue&type=script&lang=js&"
export * from "./Blankslate.vue?vue&type=script&lang=js&"
import style0 from "./Blankslate.vue?vue&type=style&index=0&id=0530c66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530c66e",
  null
  
)

export default component.exports